import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "admin@poche.com", password: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && user?.role === "admin") navigate("/admin/dashboard");
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(form.email, form.password);
      if (u.role !== "admin") {
        toast.error("Admin access required");
        return;
      }
      toast.success("Welcome to the atelier");
      navigate("/admin/dashboard");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-poche-black text-white grid grid-cols-1 md:grid-cols-2">
      <div className="hidden md:flex bg-poche-ink relative items-center justify-center">
        <div className="absolute inset-0 grain" />
        <div className="text-center relative">
          <div className="font-serif text-5xl text-poche-gold">POCHE</div>
          <div className="text-[11px] tracking-luxury uppercase text-white/55 mt-2">Atelier Admin Portal</div>
        </div>
      </div>
      <div className="flex items-center justify-center px-8 md:px-20 py-16">
        <div className="w-full max-w-sm">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Joseph Poche · Admin</p>
          <h1 className="font-serif text-4xl mt-3">Sign In.</h1>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="text-[10px] tracking-luxury uppercase text-white/55">Email</label>
              <input data-testid="admin-login-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-transparent border-b border-white/25 focus:border-poche-gold py-3 text-white focus:outline-none" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxury uppercase text-white/55">Password</label>
              <input data-testid="admin-login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full bg-transparent border-b border-white/25 focus:border-poche-gold py-3 text-white focus:outline-none" />
            </div>
            <button type="submit" data-testid="admin-login-submit" disabled={busy} className="btn-gold w-full justify-center disabled:opacity-60">
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>
          <p className="text-center text-[10px] tracking-luxury uppercase text-white/35 mt-8">
            Demo: admin@poche.com / Poche2026!
          </p>
        </div>
      </div>
    </div>
  );
}
